module.exports = __webpack_public_path__ + "res/ic_landscape.c10b6008c9d70ce2d2ea286b2c29b1c7.png";